import styled from "styled-components";
import { MobileUiVars } from "../../ui-vars";
import { motion } from "framer-motion";
import appShellUiVars from "_c/AppShell/ui-vars";
import { Button } from "_c/button";

export const Wrap = motion(styled.div`
  position: fixed;
  background: var(--bg-paper);
  z-index: 101;
  width: 100%;
  padding: 10px;
  top: calc(
    ${appShellUiVars.headMobileHeight} - 2px + ${MobileUiVars.bottomBarHeight}px
  );
  left: 0;
`);
export const Inputs = styled.div``;
export const ResetButton = styled(Button).attrs({
  flat: true,
  negative: true,
  small: true,
})`
  width: 100%;
  margin-top: 10px;
`;
